import { makeAutoObservable } from "mobx";

interface BreadcrumbObject {
  to?: string;
  from?: string;
  fromLabel?: string;
  middle?: string;
  middleLabel?: string;
  toLabel?: string;
  title?: string;
}

class Breadcrumb {
  to?: string;
  from?: string;
  fromLabel?: string;
  middle?: string;
  middleLabel?: string;
  toLabel?: string;
  title?: string;

  constructor() {
    makeAutoObservable(this);
  }

  setBreadcrumb(breadcrumb: BreadcrumbObject): void {
    this.to = breadcrumb.to;
    this.from = breadcrumb.from;
    this.fromLabel = breadcrumb.fromLabel;
    this.middle = breadcrumb.middle;
    this.middleLabel = breadcrumb.middleLabel;
    this.toLabel = breadcrumb.toLabel;
    this.title = breadcrumb.title;
  }
}

export default Breadcrumb;
